import { evalBinding } from '../../lib/bindings';

export default function TotalsBlock({ block, data }: any) {
  const cls = (block.className ? block.className + ' ' : '') + 'totals card';
  return (
    <div className={cls}>
      {block.items.map((it: any, i: number) => (
        <div key={i} className="totals-row">
          <span>{it.label}</span>
          <strong>{evalBinding(it.value, data)}</strong>
        </div>
      ))}
    </div>
  );
}
